import {
  geminiModels,
  openAiModels,
  claudeModels,
  grokModels,
  deepSeekModels,
  groqModels,
} from "../AiBotData";
import { aiProviders } from "./NewCompanyOnboarding";
import { useState } from "react";

interface Step2Props {
  aiModelEnabled: boolean;
  setAiModelEnabled: (val: boolean) => void;
  selectedAiProviderName: string | null;
  setSelectedAiProviderName: (name: string) => void;
  selectedAiModelName: string | null;
  setSelectedAiModelName: (name: string) => void;
  apiKey: any;
  setApiKey: any;
  error?: string;
  setApiKeyError?: (msg: string) => void;
}

const getModelsForProvider = (provider: string | null) => {
  switch (provider) {
    case "Gemini":
      return geminiModels;
    case "OpenAI":
      return openAiModels;
    case "Anthropic":
      return claudeModels;
    case "Grok":
      return grokModels;
    // case "DeepSeek":
    //   return deepSeekModels;
    case "Groq":
      return groqModels;
    case "OpenRouter":
      return [
        ...claudeModels,
        ...openAiModels,
        ...geminiModels,
        ...deepSeekModels,
      ];
    default:
      return [];
  }
};

const Step2 = ({
  aiModelEnabled,
  selectedAiProviderName,
  setSelectedAiProviderName,
  selectedAiModelName,
  setSelectedAiModelName,
  apiKey,
  setApiKey,
  error,
  setApiKeyError,
}: Step2Props) => {
  const [showAllModels, setShowAllModels] = useState(false);
  return (
    <div className="flex w-full flex-col gap-[30px] p-[10px]">
      <div className={`flex w-full flex-col gap-[20px]`}>
        <h3 className="flex w-full items-center gap-[6px] text-center text-[14px] font-medium capitalize not-italic leading-[1.1] text-[#444]">
          AI Provider:
        </h3>
        <div className="ai-platform-wrapper flex w-full flex-wrap items-center gap-[10px]">
          {aiProviders.map((model, index) => {
            const isActive = model.name === selectedAiProviderName;
            return (
              <div
                key={index}
                className={`connect_int_inner relative cursor-pointer ${model.name}-button ${isActive ? "active_provider" : ""} ${selectedAiProviderName && !isActive ? "dimmed" : ""}`}
                onClick={() => {
                  if (aiModelEnabled) {
                    setSelectedAiProviderName(model.name);
                    const models = getModelsForProvider(model.name);
                    if (models.length > 0) {
                      setSelectedAiModelName(models[0].name);
                      setShowAllModels(false);
                    } else {
                      setSelectedAiModelName("");
                      setShowAllModels(false);
                    }
                  }
                }}
              >
                <div className="pseudo-radio"></div>
                <div className="connect_int_name">
                  {model.icon}
                  <span> {model.name}</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      {selectedAiModelName && (
        <div className="mt-[-10px] flex w-full flex-col gap-[10px]">
          {/* <h3 className="flex w-full items-center gap-[6px] text-center text-[12px] font-medium capitalize not-italic leading-[1.1] text-[#444]">
            Select AI Model:
          </h3> */}
          <div className="flex flex-col gap-[10px] rounded-[16px] bg-[#f9f9f9] p-[10px]">
            {false && (
              <div>
                <div className="flex w-full flex-wrap items-center gap-[10px]">
                  {(showAllModels
                    ? getModelsForProvider(selectedAiProviderName)
                    : getModelsForProvider(selectedAiProviderName).slice(0, 6)
                  ).map((model, index) => {
                    const isActive = model.name === selectedAiModelName;
                    return (
                      <div
                        key={index}
                        className="flex max-w-[230px] items-center gap-[10px] rounded-[10px] border-[1.413px] bg-[#FFFFFF] p-[12px]"
                        style={{
                          opacity: aiModelEnabled ? 1 : 0.5,
                          border: isActive
                            ? "1px solid #fb5f66"
                            : "1.413px solid rgba(0,0,0,0.1)",
                          color: isActive ? "#fb5f66" : "#444",
                          cursor: aiModelEnabled ? "pointer" : "not-allowed",
                          boxShadow: isActive
                            ? "0px 4px 20px 0px rgba(251, 95, 102, 0.15)"
                            : "none",
                        }}
                        onClick={() =>
                          aiModelEnabled && setSelectedAiModelName(model.name)
                        }
                      >
                        <p
                          className="text-[13px] font-normal leading-none"
                          style={{ color: isActive ? "#fb5f66" : "#444" }}
                        >
                          {model.displayName}
                        </p>
                      </div>
                    );
                  })}
                </div>
                {getModelsForProvider(selectedAiProviderName).length > 6 && (
                  <p
                    className="mt-[6px] flex cursor-pointer items-center gap-[5px] text-[13px] text-[#fb5f66]"
                    onClick={() => setShowAllModels((prev) => !prev)}
                  >
                    {showAllModels ? "See Less" : "See More"}
                    <svg
                      width={17}
                      height={17}
                      viewBox="0 0 17 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{
                        transform: showAllModels ? "rotate(180deg)" : "none",
                        transition: "transform 0.2s",
                      }}
                    >
                      <path
                        d="M3.99619 6.19329C4.05817 6.13081 4.1319 6.08121 4.21314 6.04736C4.29438 6.01352 4.38152 5.99609 4.46952 5.99609C4.55753 5.99609 4.64467 6.01352 4.72591 6.04736C4.80715 6.08121 4.88088 6.13081 4.94286 6.19329L7.99619 9.24663C8.05817 9.30911 8.1319 9.35871 8.21314 9.39255C8.29438 9.4264 8.38152 9.44382 8.46952 9.44382C8.55753 9.44382 8.64467 9.4264 8.72591 9.39255C8.80715 9.35871 8.88088 9.30911 8.94286 9.24663L11.9962 6.19329C12.0582 6.13081 12.1319 6.08121 12.2131 6.04736C12.2944 6.01352 12.3815 5.99609 12.4695 5.99609C12.5575 5.99609 12.6447 6.01352 12.7259 6.04736C12.8071 6.08121 12.8809 6.13081 12.9429 6.19329C13.067 6.3182 13.1367 6.48717 13.1367 6.66329C13.1367 6.83942 13.067 7.00838 12.9429 7.13329L9.88286 10.1933C9.50786 10.5678 8.99953 10.7782 8.46952 10.7782C7.93952 10.7782 7.43119 10.5678 7.05619 10.1933L3.99619 7.13329C3.87202 7.00838 3.80233 6.83942 3.80233 6.66329C3.80233 6.48717 3.87202 6.3182 3.99619 6.19329Z"
                        fill="#FB5F66"
                      />
                    </svg>
                  </p>
                )}
              </div>
            )}
            {selectedAiModelName && (
              <div className="mt-[6px] flex flex-col gap-[10px]">
                <h3 className="flex items-center gap-[2px] text-[12px] capitalize leading-[110%] text-[#444]">
                  {selectedAiProviderName} Secret Key{" "}
                  <div className="secret-key-icon relative">
                    <svg
                      className=""
                      width={17}
                      height={17}
                      viewBox="0 0 17 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.80273 5.52669H9.13607V6.86003H7.80273V5.52669ZM7.80273 8.19336H9.13607V12.1934H7.80273V8.19336ZM8.4694 2.19336C4.7894 2.19336 1.80273 5.18003 1.80273 8.86003C1.80273 12.54 4.7894 15.5267 8.4694 15.5267C12.1494 15.5267 15.1361 12.54 15.1361 8.86003C15.1361 5.18003 12.1494 2.19336 8.4694 2.19336ZM8.4694 14.1934C5.5294 14.1934 3.13607 11.8 3.13607 8.86003C3.13607 5.92003 5.5294 3.52669 8.4694 3.52669C11.4094 3.52669 13.8027 5.92003 13.8027 8.86003C13.8027 11.8 11.4094 14.1934 8.4694 14.1934Z"
                        fill="#666666"
                      />
                    </svg>
                    <p className="sm-tooltip flex-cnt h-max max-w-[250px] bg-[#222] py-[5px]">
                      <span className="sm-tooltip_text !normal-case">
                        You can change this configuration anytime from AI
                        Settings tab.
                      </span>
                    </p>
                  </div>
                </h3>
                <div className="w-full">
                  <input
                    type="text"
                    value={apiKey}
                    onChange={(e) => {
                      setApiKey(e.target.value);
                      setApiKeyError && setApiKeyError("");
                    }}
                    placeholder="Type secret key..."
                    className="rounded-[10px] border border-black/10 bg-white p-[15px]"
                  />
                  {error && (
                    <div className="mt-1 text-[12px] text-[#fb5f66]">
                      {error}
                    </div>
                  )}
                </div>

                <p className="flex items-center gap-[8px] text-[12px] italic leading-none text-[#6D6D6D]">
                  Encrypted with AES-256 at rest
                </p>
              </div>
            )}
          </div>
        </div>
      )}
      {false && (
        <div className="mt-[-10px] flex flex-col gap-[10px] border-t border-t-[rgba(0,0,0,0.1)] pt-[20px]">
          <h3 className="text-[12px] font-medium capitalize leading-[110%] text-[#444]">
            Default AI Model
          </h3>
          <div className="flex w-full items-center gap-[10px] rounded-[10px] bg-[#f9f9f9] p-[10px]">
            <svg
              className="flex-shrink-0"
              width={17}
              height={17}
              viewBox="0 0 17 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.80273 5.52669H9.13607V6.86003H7.80273V5.52669ZM7.80273 8.19336H9.13607V12.1934H7.80273V8.19336ZM8.4694 2.19336C4.7894 2.19336 1.80273 5.18003 1.80273 8.86003C1.80273 12.54 4.7894 15.5267 8.4694 15.5267C12.1494 15.5267 15.1361 12.54 15.1361 8.86003C15.1361 5.18003 12.1494 2.19336 8.4694 2.19336ZM8.4694 14.1934C5.5294 14.1934 3.13607 11.8 3.13607 8.86003C3.13607 5.92003 5.5294 3.52669 8.4694 3.52669C11.4094 3.52669 13.8027 5.92003 13.8027 8.86003C13.8027 11.8 11.4094 14.1934 8.4694 14.1934Z"
                fill="#666666"
              />
            </svg>
            <p className="text-[13px] leading-[150%] text-[#666]">
              Start with <span className="font-medium">200</span> free message
              via <span className="font-medium">Haiku 3.5</span> (no setup
              needed). For more connect your{" "}
              <span className="font-medium">OpenAI</span> API for full model
              access. You can <span className="font-medium">skip</span> to
              continue without an AI Provider.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Step2;
